import { render, staticRenderFns } from "./StatusModal.vue?vue&type=template&id=24fdfdae&scoped=true&"
import script from "./StatusModal.vue?vue&type=script&lang=js&"
export * from "./StatusModal.vue?vue&type=script&lang=js&"
import style0 from "./StatusModal.vue?vue&type=style&index=0&id=24fdfdae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fdfdae",
  null
  
)

export default component.exports